import { render, staticRenderFns } from "./Game.vue?vue&type=template&id=0ead64b1&scoped=true&"
import script from "./Game.vue?vue&type=script&lang=js&"
export * from "./Game.vue?vue&type=script&lang=js&"
import style0 from "./Game.vue?vue&type=style&index=0&id=0ead64b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ead64b1",
  null
  
)

export default component.exports